/**
 * Utilidad para generar y gestionar deviceId único por navegador
 */

import { v4 as uuidv4 } from 'uuid';
import { StorageUtil } from './storage.util';

export const DeviceUtil = {
  /**
   * Obtiene o genera un deviceId único para este navegador
   * Este ID persiste incluso después del logout para identificar el dispositivo
   */
  getOrCreateDeviceId(): string {
    let deviceId = StorageUtil.getDeviceId();

    if (!deviceId) {
      deviceId = this.generateDeviceId();
      StorageUtil.setDeviceId(deviceId);
    }

    return deviceId;
  },

  /**
   * Genera un nuevo deviceId único
   */
  generateDeviceId(): string {
    return uuidv4();
  },

  /**
   * Obtiene información adicional del dispositivo (opcional)
   * Útil para logging o debugging
   */
  getDeviceInfo(): {
    deviceId: string;
    userAgent: string;
    platform: string;
    timestamp: number;
  } {
    return {
      deviceId: this.getOrCreateDeviceId(),
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      timestamp: Date.now(),
    };
  },
};
